module.exports = __webpack_public_path__ + "static/media/IMG_3068.9c430b73.JPG";